import React from "react";
import styled from "@emotion/styled";
import { useIntl } from "react-intl";

import ParkkiTheme from "themes/ParkkiTheme";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const CollapsibleHeaderContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  padding-right: ${ParkkiTheme.spacings.base};
  padding-left: ${ParkkiTheme.spacings.base};
  padding-top: ${ParkkiTheme.spacings.xsmall};
  padding-bottom: ${ParkkiTheme.spacings.xsmall};
`;

const CollapsibleHeaderTitle = styled.div`
  margin-right: ${ParkkiTheme.spacings.xsmall};
`;

const ArrowDown = styled(KeyboardArrowDownIcon)`
  width: auto;
  height: 16px;
`;

const ArrowUp = styled(KeyboardArrowUpIcon)`
  width: auto;
  height: 16px;
`;

type Props = {
  allSelected: boolean;
  collapsed: boolean;
};

function CollapsibleHeader({ allSelected, collapsed }: Props): JSX.Element {
  const { formatMessage } = useIntl();

  if (allSelected) return <></>;

  return (
    <CollapsibleHeaderContainer>
      <CollapsibleHeaderTitle>
        {formatMessage({
          id: `components.selectedLayersSection.${collapsed ? "hide" : "see"}`,
        })?.toUpperCase()}
      </CollapsibleHeaderTitle>
      {collapsed ? <ArrowDown /> : <ArrowUp />}
    </CollapsibleHeaderContainer>
  );
}

export default CollapsibleHeader;
